import { render, staticRenderFns } from "./ActionRequiredScrollBadge.vue?vue&type=template&id=0a1f0763&scoped=true&"
import script from "./ActionRequiredScrollBadge.vue?vue&type=script&lang=ts&"
export * from "./ActionRequiredScrollBadge.vue?vue&type=script&lang=ts&"
import style0 from "./ActionRequiredScrollBadge.vue?vue&type=style&index=0&id=0a1f0763&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1f0763",
  null
  
)

export default component.exports